import { environment } from '../../../environments/environment';

export function resolveGraphqlEndpoint(): string {
  const url = environment.graphqlUrl?.trim();
  if (!url) {
    throw new Error('GraphQL endpoint is not configured. Set API_URL in .env.');
  }
  return url;
}

export function resolveApiBaseUrl(): string {
  return resolveGraphqlEndpoint().replace(/\/graphql\/?$/i, '');
}

export function resolveMicrosoftLoginUrl(): string {
  return `${resolveApiBaseUrl()}/auth/microsoft/login`;
}
